import React from "react";
// import { Link } from "gatsby";
// import { StaticImage } from "gatsby-plugin-image";
import Dropdowns from "./DropDowns";

export default function Nanbar() {
  return (
    <div>
      <Dropdowns />
    </div>
  );
}
